import React from 'react';
import '../css/contact.css';
import '../css/form.css';
// import '../js/main.js';
import '../fonts/font-awesome-4.7.0/css/font-awesome.min.css';
import { Row, Col } from 'react-bootstrap';
import Button from '../components/Button';
import { Formik, Form, Field, ErrorMessage } from 'formik';

function Contact(props) {
  return (
    <section id='contact' className={`${props.openMenu ? 'display-none' : ''}`}>
      <Row className='contact-row'>
        <Col className='form' xs='11' sm='6'>
          {' '}
          <Formik
            initialValues={{ name: '', email: '', subject: '', message: '' }}
            validate={values => {
              const errors = {};
              if (!values.name) {
                errors.name = (
                  <div
                    data-validate='Required'
                    className='alert-validate'
                  ></div>
                );
              } else if (
                !/[A-Z][a-zA-Z][^#&<>"~;$^%{}?]{1,20}$/g.test(values.name)
              ) {
                errors.name = (
                  <div
                    data-validate='Valid Name Required'
                    className='alert-validate'
                  ></div>
                );
              }
              if (!values.email) {
                errors.email = (
                  <div
                    data-validate='Required'
                    className='alert-validate'
                  ></div>
                );
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,64}$/i.test(values.email)
              ) {
                errors.email = (
                  <div
                    data-validate='Valid Email Required'
                    className='alert-validate'
                  ></div>
                );
              }
              if (!values.subject) {
                errors.subject = (
                  <div
                    data-validate='Required'
                    className='alert-validate'
                  ></div>
                );
              }
              if (!values.message) {
                errors.message = (
                  <div
                    data-validate='Required'
                    className='alert-validate'
                  ></div>
                );
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                setSubmitting(false);
                console.log(123);
              }, 400);
            }}
          >
            {({ isSubmitting }) => (
              <div className='wrap-contact100'>
                <Form
                  action='POST'
                  data-netlify='true'
                  className='contact100-form validate-form'
                >
                  <div className='wrap-input100 validate-input'>
                    <span className='label-input100'>Name:</span>
                    <Field
                      className='input100 '
                      maxLength='20'
                      type='name'
                      name='name'
                    />
                    <span className='focus-input100'></span>
                    <ErrorMessage name='name' component='div' />
                  </div>
                  <div className='wrap-input100 validate-input'>
                    <span className='label-input100'>Email:</span>
                    <Field
                      className='input100'
                      maxLength='64'
                      type='email'
                      name='email'
                    />
                    <span className='focus-input100'></span>
                    <ErrorMessage name='email' component='div' />
                  </div>
                  <div className='wrap-input100'>
                    <span className='label-input100'>Subject:</span>
                    <Field
                      maxLength='64'
                      className='input100'
                      type='subject'
                      name='subject'
                    />
                    <span className='focus-input100'></span>
                    <ErrorMessage name='subject' component='div' />
                  </div>
                  <div className='wrap-input100 validate-input'>
                    <span className='label-input100'>Message:</span>
                    <Field
                      maxLength='64'
                      className='textarea input100'
                      type='message'
                      name='message'
                    />
                    <span className='focus-input100'></span>
                    <ErrorMessage name='message' component='div' />
                  </div>
                  <div className='field'>
                    <div data-netlify-recaptcha='true'></div>
                  </div>
                  <Button
                    value='Send Message'
                    type='submit'
                    buttonClass={'contact-button'}
                    disabled={isSubmitting}
                  />
                </Form>
              </div>
            )}
          </Formik>
        </Col>
        <Col className='info' xs='5'>
          <div className='info-col'>
            <p>Phone:</p>
            <p>-On Request</p>
            <p>Email:</p>
            <a href='mailto:jamiesparkeract@gmail.com'>
              jamiesparkeract@gmail.com{' '}
            </a>
            <p>Location:</p>
            <p>Czech republic, Prague </p>
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default Contact;
